'use strict';

var SpillPaxGapAggregationFactory = function SpillPaxGapAggregationFactory(DataAggregationFactory) {
  function SpillPaxGapAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-flattened-services-mode', 'spill-pax-gap');
  }
  SpillPaxGapAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  SpillPaxGapAggregation.constructor = SpillPaxGapAggregation;
  SpillPaxGapAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  SpillPaxGapAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedSpillPaxGap = [],
      map = [];
    var self = this;
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      var service = record.service;
      var mapServiceIndex = map.indexOf(service);
      var dow = record.dow;
      var spillPaxGap = {};
      if (mapServiceIndex === -1) {
        spillPaxGap[dow] = self.getMetricValue(record.spillPaxGap, metricsKeys);
        spillPaxGap.potentialRevenue = self.getMetricValue(record.potentialRevenue, metricsKeys);
        spillPaxGap.service = service;
        aggregatedSpillPaxGap.push(spillPaxGap);
        map.push(service);
      } else if (!aggregatedSpillPaxGap[mapServiceIndex][dow]) {
        aggregatedSpillPaxGap[mapServiceIndex][dow] = self.getMetricValue(record.spillPaxGap, metricsKeys, true);
        aggregatedSpillPaxGap[mapServiceIndex].potentialRevenue += self.getMetricValue(record.potentialRevenue, metricsKeys, true);
      } else {
        aggregatedSpillPaxGap[mapServiceIndex][dow] += self.getMetricValue(record.spillPaxGap, metricsKeys, true);
        aggregatedSpillPaxGap[mapServiceIndex].potentialRevenue += self.getMetricValue(record.potentialRevenue, metricsKeys, true);
      }
    }
    return self.sortBy(aggregatedSpillPaxGap, 'potentialRevenue', 'DESC');
  };
  return SpillPaxGapAggregation;
};
SpillPaxGapAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = SpillPaxGapAggregationFactory;